import './EmptyState.scss'

import PropTypes from 'prop-types'
import { Text } from '@fable/components'

const EmptyState = ({
  accentColor,
  bgImage,
  description,
  mainImage,
  title,
}) => {
  return (
    <div className="empty-state" style={{ background: `url(${bgImage})` }}>
      <div className="empty-inner">
        <img src={mainImage} alt="Empty State Icon" />
        <Text
          className="empty-title"
          type="subhead"
          sizing="S"
          color={accentColor}
        >
          {title}
        </Text>
        <label>{description}</label>
      </div>
    </div>
  )
}

EmptyState.propTypes = {
  accentColor: PropTypes.string.isRequired,
  bgImage: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  mainImage: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

EmptyState.defaultProps = {
  accentColor: '',
  bgImage: '',
  description: '',
  mainImage: '',
  title: '',
}

export default EmptyState
